"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payload = void 0;
var ParsedPayload_1 = require("../classes/ParsedPayload");
var constants_1 = require("./constants");
var Field_1 = require("./Field");
var Utils_1 = require("./Utils");
var Payload = /** @class */ (function () {
    function Payload() {
    }
    Payload.prototype.generateMerchantAccountInformation = function (_a) {
        var _b = _a.GUI, GUI = _b === void 0 ? constants_1.DEFAULT_MERCHANT_GUI : _b, key = _a.key, description = _a.description, pss = _a.pss;
        var MERCHANT_ACCOUNT_GUI = Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_GUI, GUI);
        var MERCHANT_ACCOUNT_KEY = Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_KEY, key);
        var MERCHANT_ACCOUNT_DESCRIPTION = description
            ? Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_DESCRIPTION, description)
            : '';
        var MERCHANT_ACCOUNT_PSS = pss
            ? Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_PSS, pss)
            : '';
        return Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION, MERCHANT_ACCOUNT_GUI +
            MERCHANT_ACCOUNT_KEY +
            MERCHANT_ACCOUNT_DESCRIPTION +
            MERCHANT_ACCOUNT_PSS);
    };
    Payload.prototype.generateAdditionalFieldInformation = function (_a) {
        var _b = _a.txid, txid = _b === void 0 ? constants_1.DEFAULT_TXID : _b;
        var FIELD_TXID = Field_1.Field.stringify(constants_1.IDS.ID_ADDITIONAL_DATA_FIELD_TEMPLATE_TXID, txid);
        return Field_1.Field.stringify(constants_1.IDS.ID_ADDITIONAL_DATA_FIELD_TEMPLATE, FIELD_TXID);
    };
    Payload.prototype.generateCRC16 = function (currentPayload) {
        var payload = "" + currentPayload + constants_1.IDS.ID_CRC16 + "04";
        var CRC16 = Utils_1.Utils.getCRC16(payload);
        return Field_1.Field.stringify(constants_1.IDS.ID_CRC16, CRC16);
    };
    Payload.prototype.generate = function (options) {
        var payload = [''];
        var PAYLOAD_FORMAT_INDICATOR = Field_1.Field.stringify(constants_1.IDS.ID_PAYLOAD_FORMAT_INDICATOR, '01');
        payload.push(PAYLOAD_FORMAT_INDICATOR);
        var MERCHANT_ACCOUNT = this.generateMerchantAccountInformation({
            key: options.pixKey,
            GUI: options.GUI,
            description: options.merchant.description,
            pss: options.merchant.pss
        });
        payload.push(MERCHANT_ACCOUNT);
        var CATEGORY_CODE = Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_CATEGORY_CODE, options.merchant.categoryCode || '0000');
        payload.push(CATEGORY_CODE);
        var TRANSACTION_CURRENCY = Field_1.Field.stringify(constants_1.IDS.ID_TRANSACTION_CURRENCY, options.transactionCurrency || '986');
        payload.push(TRANSACTION_CURRENCY);
        if (options.amount) {
            var stringPixAmount = options.amount.toFixed(2);
            var TRANSACTION_AMOUNT = Field_1.Field.stringify(constants_1.IDS.ID_TRANSACTION_AMOUNT, stringPixAmount);
            payload.push(TRANSACTION_AMOUNT);
        }
        var COUNTRY_CODE = Field_1.Field.stringify(constants_1.IDS.ID_COUNTRY_CODE, options.countryCode || 'BR');
        payload.push(COUNTRY_CODE);
        var MERCHANT_NAME = Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_NAME, options.merchant.name);
        payload.push(MERCHANT_NAME);
        var MERCHANT_CITY = Field_1.Field.stringify(constants_1.IDS.ID_MERCHANT_CITY, Utils_1.Utils.formatCity(options.merchant.city));
        payload.push(MERCHANT_CITY);
        var ADDITIONAL_FIELD_INFORMATION = this.generateAdditionalFieldInformation({
            txid: options.txid
        });
        payload.push(ADDITIONAL_FIELD_INFORMATION);
        var CRC16 = this.generateCRC16(payload.join(''));
        payload.push(CRC16);
        var parsedPayload = this.parse(payload.join(''));
        return parsedPayload;
    };
    Payload.prototype.parse = function (payload) {
        var fields = Field_1.Field.parse(payload);
        return new ParsedPayload_1.ParsedPayload(payload, fields);
    };
    return Payload;
}());
var payload = new Payload();
exports.Payload = payload;
